export default "__VITE_PUBLIC_ASSET__968d7284__"